<template>
    <SideFormSection>
        <template #title> Trigger </template>
        <template #rawContent>
            <Card
                title="Trigger"
                iconName="gears"
            >
                <template #content>
                    <!-- Dummy input -->
                    <FormControl label="Trigger">
                        <TextInput
                            :value="automation.triggerType.label"
                            :disabled="true"
                        />
                    </FormControl>

                    <ApiForm
                        :url="
                            urlFactory.makeAutomationUpdateTriggerSettingsUrl(
                                automation.id,
                            )
                        "
                        method="POST"
                        ref="apiFormRef"
                    >
                        <XMinutesBeforeMeetingStartsTriggerForm
                            v-if="
                                automation.triggerType.key ===
                                AutomationTriggerTypeEnum.XMinutesBeforeMeetingStarts
                            "
                            :services="services"
                            :triggerData="
                                automation.getXMinutesBeforeMeetingStartsTriggerData()
                            "
                            :errors="apiFormRef?.response?.getErrors() ?? null"
                        />
                    </ApiForm>
                </template>
                <template
                    v-if="automation.hasTriggerSettings()"
                    #actions
                >
                    <Button
                        @click="submit()"
                        :loading="apiFormRef?.loading.valueOf()"
                        iconName="save"
                        color="dark"
                    >
                        Save
                    </Button>
                </template>
            </Card>
        </template>
    </SideFormSection>
</template>

<script setup lang="ts">
    import { UrlFactory } from '@/Shared/Url/UrlFactory'
    import { ref, type PropType } from 'vue'
    import SideFormSection from '@/Shared/Component/SideFormSection.vue'
    import Card from '@/Shared/Component/Card.vue'
    import Automation from '@/App/Automation/Entity/Automation'
    import XMinutesBeforeMeetingStartsTriggerForm from '@/App/Automation/Component/TriggerForm/XMinutesBeforeMeetingStartsTriggerForm.vue'
    import {
        AutomationTriggerTypeEnum,
        ResponseJsonKeyEnum,
    } from '@/Shared/AutoGenerated/Main'
    import ApiForm from '@/Shared/Component/Forms/ApiForm.vue'
    import type { ApiFormRefType } from '@/Shared/AutoGenerated/Types'
    import type ApiFormResponseType from '@/Shared/Component/Forms/ApiFormResponseType'
    import Service from '@/App/Service/Entity/Service'
    import TextInput from '@/Shared/Component/Forms/TextInput.vue'
    import FormControl from '@/Shared/Component/Forms/FormControl.vue'
    import Button from '@/Shared/Component/Button.vue'

    const emits = defineEmits<{
        onSuccess: [{ automation: Automation }]
    }>()

    const props = defineProps({
        automation: {
            type: Object as PropType<Automation>,
            required: true,
        },
        services: {
            type: Object as PropType<Service[]>,
            required: true,
        },
    })

    const apiFormRef = ref<ApiFormRefType>(null)

    const submit = () => {
        apiFormRef.value?.submit()?.then((response: ApiFormResponseType) => {
            emits('onSuccess', {
                automation: response.getHydratedAutomation(
                    ResponseJsonKeyEnum.App_Automation_Update_AutomationData,
                ),
            })
        })
    }
    const urlFactory = new UrlFactory()
</script>
